<div class="verification-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
    </div>
  </div>

  <div class="verification-card">
    <div class="card-header">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>
    </div>

    <div class="card-content" *ngIf="!verificationSuccess">
      <h2>Verify Your Email</h2>
      <div class="email-badge">
        <svg class="email-icon" viewBox="0 0 24 24">
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
          ></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        <span>{{ email }}</span>
      </div>
      <p class="instruction">
        We've sent a verification code to your email address. Please enter the
        6-digit code below to verify your account.
      </p>

      <form [formGroup]="verificationForm" (ngSubmit)="verifyEmail()">
        <div class="code-input">
          <input
            type="text"
            formControlName="code"
            maxlength="6"
            placeholder="000000"
            pattern="[0-9]{6}"
            autocomplete="one-time-code"
          />
        </div>

        <div class="info-box">
          <svg class="info-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <span>The verification code will expire in 15 minutes</span>
        </div>

        <div class="error-container" *ngIf="errorMessage">
          <div class="error-message">
            <svg viewBox="0 0 24 24" class="error-icon">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            {{ errorMessage }}
          </div>
        </div>

        <button
          type="submit"
          class="verify-btn"
          [disabled]="verificationForm.invalid || isSubmitting"
        >
          <span *ngIf="!isSubmitting">Verify Email</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>
      </form>

      <div class="card-footer">
        <a routerLink="/login" class="back-link">Back to Login</a>
      </div>
    </div>

    <div class="card-content success-content" *ngIf="verificationSuccess">
      <div class="success-animation">
        <svg class="success-icon" viewBox="0 0 24 24">
          <path
            class="success-icon-circle"
            d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z"
          ></path>
          <path class="success-icon-check" d="M7.8,13.2l2.8,2.8l5.6-5.6"></path>
        </svg>
      </div>
      <h2 class="success-title">Verification Successful!</h2>
      <p class="success-message">{{ successMessage }}</p>
      <div class="redirect-indicator">
        <div class="redirect-spinner"></div>
        <span>Redirecting to login page...</span>
      </div>
    </div>
  </div>
</div>
